import moment from 'moment'

const Services = {
  ReturnSiglaEstado: estado => {
    switch (estado) {
      case 'Acre':
        return 'ac'
      case 'Alagoas':
        return 'al'
      case 'Amapá':
        return 'ap'
      case 'Amazonas':
        return 'am'
      case 'Bahia':
        return 'ba'
      case 'Ceará':
        return 'ce'
      case 'Distrito Federal':
        return 'df'
      case 'Espírito Santo':
        return 'es'
      case 'Goiás':
        return 'go'
      case 'Maranhão':
        return 'ma'
      case 'Mato Grosso':
        return 'mt'
      case 'Mato Grosso do Sul':
        return 'ms'
      case 'Minas Gerais':
        return 'mg'
      case 'Pará':
        return 'pa'
      case 'Paraíba':
        return 'pb'
      case 'Paraná':
        return 'pr'
      case 'Pernambuco':
        return 'pe'
      case 'Piauí':
        return 'pi'
      case 'Rio de Janeiro':
        return 'rj'
      case 'Rio Grande do Norte':
        return 'rn'
      case 'Rio Grande do Sul':
        return 'rs'
      case 'Rondônia':
        return 'ro'
      case 'Roraima':
        return 'rr'
      case 'Santa Catarina':
        return 'sc'
      case 'São Paulo':
        return 'sp'
      case 'Sergipe':
        return 'se'
      case 'Tocantins':
        return 'to'
      default:
        return ''
    }
  },
  TruncateString: (str, num) => {
    if (str.length <= num) {
      return str
    }
    return str.slice(0, num) + '...'
  },
  RemoveCaracteresEspeciais: texto => {
    return texto
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9]/g, '-')
      .toLowerCase()
  },
  RetornaEstados: estado => {
    switch (estado) {
      case 'Acre':
        return 'AC'
      case 'Alagoas':
        return 'AL'
      case 'Amapá':
        return 'AP'
      case 'Amazonas':
        return 'AM'
      case 'Bahia':
        return 'BA'
      case 'Ceará':
        return 'CE'
      case 'Distrito Federal':
        return 'DF'
      case 'Espírito Santo':
        return 'ES'
      case 'Goiás':
        return 'GO'
      case 'Maranhão':
        return 'MA'
      case 'Mato Grosso':
        return 'MT'
      case 'Mato Grosso do Sul':
        return 'MS'
      case 'Minas Gerais':
        return 'MG'
      case 'Pará':
        return 'PA'
      case 'Paraíba':
        return 'PB'
      case 'Paraná':
        return 'PR'
      case 'Pernambuco':
        return 'PE'
      case 'Piauí':
        return 'PI'
      case 'Rio de Janeiro':
        return 'RJ'
      case 'Rio Grande do Norte':
        return 'RN'
      case 'Rio Grande do Sul':
        return 'RS'
      case 'Rondônia':
        return 'RO'
      case 'Roraima':
        return 'RR'
      case 'Santa Catarina':
        return 'SC'
      case 'São Paulo':
        return 'SP'
      case 'Sergipe':
        return 'SE'
      case 'Tocantins':
        return 'TO'
      default:
        return ''
    }
  },
  ReturnLabelURL: (estad, city) => {
    try {
      if (!estad || typeof estad !== 'string' || !city || typeof city !== 'string') {
        return ':location'
      }

      const ct = `${city
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '-')
        .toLowerCase()}`

      if (estad.length === 2) return `${estad.toLowerCase()}-${ct}`

      const estadoFormatado = Services.RetornaEstados(estad)
      if (!estadoFormatado || typeof estadoFormatado !== 'string') {
        return ':location'
      }

      const label = `${estadoFormatado.toLowerCase()}-${ct}`
      return label
    } catch (e) {
      return ':location'
    }
  },
  ReturnValorPorcentagem: (porcentagem, valor) => {
    return ((valor * porcentagem) / 100).toFixed(2)
  },
  ReturnHoraMin: hor => {
    return moment(hor).format('HH:mm')
  },
  RetornaPeriodoSelect: array => {
    const horarioInicial = new Date(array[0].dataInicio)
    const horarioFinal = new Date(array[array.length - 1].dataFinal)

    return `${Services.ReturnHoraMin(horarioInicial)} às ${Services.ReturnHoraMin(horarioFinal)}`
  },
  RetornaLabelMensalista: idx => {
    const mesesMensalista = ['Mensal', 'Trimestral', 'Semestral', 'Anual', 'Indeterminado']
    return mesesMensalista[idx]
  },
  RetornaPeriodo: idx => {
    switch (idx) {
      case 0:
        return 1
      case 1:
        return 3
      case 2:
        return 6
      case 3:
        return 12
      case 4:
        return 13
      default:
        return 0
    }
  },
  RetornaMinutagem: minutos => {
    if (minutos >= 60 && minutos < 1440) {
      let minutagem = minutos / 60 + ''
      let retorno = minutagem.split('.')
      return retorno[0] + ' hora(s)'
    } else if (minutos < 60) {
      return minutos + ' minuto(s)'
    } else {
      let minutagem = minutos / 1440 + ''
      let retorno = minutagem.split('.')
      return retorno[0] + ' dia(s)'
    }
  },
  OrganizarDias: (data, range) => {
    const days = []

    for (let i = range * -1; i <= range; i++) {
      const newDate = moment(data)
      newDate.add(i, 'days')
      days.push(newDate)
    }

    return days
  },
  ReturnStringDay: data => {
    switch (data.getDay()) {
      case 0:
        return 'DOM'
      case 1:
        return 'SEG'
      case 2:
        return 'TER'
      case 3:
        return 'QUA'
      case 4:
        return 'QUI'
      case 5:
        return 'SEX'
      case 6:
        return 'SÁB'
      default:
        return 'Erro'
    }
  },
  VerificaValidade: (dia, maxAgend) => {
    const dataDay = moment()
    const limite = maxAgend || 365
    const diaMax = moment().add(limite, 'days')

    if (moment(dia).isSame(dataDay, 'day')) {
      return true
    }

    if (moment(dia).isAfter(diaMax, 'day')) {
      return false
    }

    return moment(dia).isAfter(dataDay, 'day')
  },
  ReturnMes: (centerDay, arrayDias) => {
    const formatMonth = date => {
      const month = moment(date).format('MMMM')
      return month.charAt(0).toUpperCase() + month.slice(1)
    }

    const centerMonth = formatMonth(centerDay)
    const uniqueMonths = Array.from(new Set(arrayDias.map(date => formatMonth(date))))

    if (uniqueMonths.length === 1) {
      return centerMonth
    }

    const differentMonths = uniqueMonths.filter(month => month !== centerMonth)

    if (differentMonths.length === 0) {
      return centerMonth
    }

    const differentMonth = differentMonths[0]
    const differentMonthIndex = arrayDias.findIndex(date => formatMonth(date) === differentMonth)
    const centerDayIndex = arrayDias.findIndex(date => date.isSame(centerDay, 'day'))

    if (differentMonthIndex < centerDayIndex) {
      return `${differentMonth} / ${centerMonth}`
    } else {
      return `${centerMonth} / ${differentMonth}`
    }
  },
  ReturnDiaSemana(mode, data) {
    const dias = [
      ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      ['Domingos', 'Segundas', 'Terças', 'Quartas', 'Quintas', 'Sextas', 'Sábados'],
      [
        'Domingo',
        'Segunda-feira',
        'Terça-feira',
        'Quarta-feira',
        'Quinta-feira',
        'Sexta-feira',
        'Sábado',
      ],
      [
        'Domingos',
        'Segundas-feiras',
        'Terças-feiras',
        'Quartas-feiras',
        'Quintas-feiras',
        'Sextas-feiras',
        'Sábados',
      ],
      [
        'Domingos',
        'Segundas - feiras',
        'Terças - feiras',
        'Quartas - feiras',
        'Quintas - feiras',
        'Sextas - feiras',
        'Sábados',
      ],
    ]
    return dias[mode - 1][data.getDay()]
  },
  DataFormat(format, date, agenda) {
    const data = new Date(date)
    const dia = data.getDate().toString().padStart(2, '0')
    const mes = (data.getMonth() + 1).toString().padStart(2, '0')
    const ano = data.getFullYear()

    switch (format) {
      case 'DD/MM/YY':
        return `${dia}/${mes}/${ano.toString().slice(-2)}`
      case 'DD/MM/YYYY':
        return `${dia}/${mes}/${ano}`
      case 'dia,DD/MM/YY':
        return `${moment(data).format('ddd, DD/MM/YY')}`

      case 'label-hf':
        return `${ReturnLabelHF(data.getDay())} ${Services.ReturnDiaSemana(2, data)} das ${Services.RetornaPeriodoSelect(agenda)}`
      case 'label-hf-2':
        return `A partir de ${Services.ReturnDiaSemana(1, data)}, ${data.getDate()} de ${ReturnMes(data.getMonth() + 1)} de ${ano}`
      case 'input-nascimento': {
        const cleanValue = date.replace(/\D/g, '')
        if (cleanValue.length <= 2) return cleanValue
        if (cleanValue.length <= 4) return `${cleanValue.slice(0, 2)}/${cleanValue.slice(2)}`
        return `${cleanValue.slice(0, 2)}/${cleanValue.slice(2, 4)}/${cleanValue.slice(4, 8)}`
      }

      default:
        return ''
    }

    function ReturnLabelHF(dia) {
      return dia === 0 || dia === 6 ? 'Todos os' : 'Todas as'
    }

    function ReturnMes(mes) {
      const meses = [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ]
      return meses[mes - 1] || 'Erro'
    }
  },
  RetornaRegraCancelamentoSwal: regra => {
    function retornaMinutagem(minutos) {
      if (minutos >= 60 && minutos < 1440) {
        let minutagem = minutos / 60 + ''
        let retorno = minutagem.split('.')
        return retorno[0] + ' hora(s)'
      } else if (minutos < 60) {
        return minutos + ' minuto(s)'
      } else {
        let minutagem = minutos / 1440 + ''
        let retorno = minutagem.split('.')
        return retorno[0] + ' dia(s)'
      }
    }

    if (regra.minutosAntecedencia === 0)
      return `Cancelamento GRATUITO até o horário do agendamento.`
    else if (
      regra.minutosAntecedencia !== 0 &&
      regra.porcentagemMulta === 0 &&
      regra.permitirCancelamentoPosHorario === 1
    ) {
      return `Você pode cancelar até ${retornaMinutagem(regra.minutosAntecedencia)} antes do horário.`
    } else if (
      regra.minutosAntecedencia !== 0 &&
      regra.porcentagemMulta > 0 &&
      regra.permitirCancelamentoPosHorario === 1
    ) {
      return `Você pode cancelar GRATUITAMENTE até ${retornaMinutagem(
        regra.minutosAntecedencia,
      )} antes do horário. Se você cancelar após o horário limite, será cobrada uma taxa de ${
        regra.porcentagemMulta
      }% do valor total do agendamento. Se o pagamento for um sinal, ele será a multa.`
    } else if (regra.minutosAntecedencia !== 0 && regra.permitirCancelamentoPosHorario === 0) {
      return `Você pode cancelar GRATUITAMENTE até ${retornaMinutagem(
        regra.minutosAntecedencia,
      )} antes do horário. Após o horário limite NÃO será possível cancelar e você deverá entrar em contato com o Gestor pelo chat.`
    } else return regra.permitirCancelamentoPosHorario
  },
  ReturnMetodoPay: metodo => {
    switch (metodo) {
      case 'MAQUINA_CARTAO':
        return 'Máquina no local'
      case 'DINHEIRO':
        return 'Dinheiro'
      case 'PIX':
        return 'PIX'
      case 'CARTAO_CREDITO':
        return 'Cartão de crédito'
    }
  },
  FormatValor: valor => {
    if (typeof valor === 'number') {
      return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    } else if (typeof valor === 'string') {
      return parseFloat(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    } else {
      return ''
    }
  },
  RetornaPeriodoHorario: horario => {
    const dataI = new Date(horario.dataInicio)
    const dataF = new Date(horario.dataFinal)
    return `${dataI.getHours() >= 10 ? dataI.getHours() : '0' + dataI.getHours()}:${
      dataI.getMinutes() < 10 ? '0' + dataI.getMinutes() : dataI.getMinutes()
    } às ${dataF.getHours() >= 10 ? dataF.getHours() : '0' + dataF.getHours()}:${
      dataF.getMinutes() < 10 ? '0' + dataF.getMinutes() : dataF.getMinutes()
    }`
  },
  MinutesToHoursReduced: minutes => {
    const duration = moment.duration(minutes, 'minutes')
    const horas = duration.hours()
    const minutosRestantes = duration.minutes()
    let texto = ''

    if (horas > 0) {
      texto += `${horas}h`
    }

    if (minutosRestantes > 0) {
      if (texto !== '') {
        texto += ' e '
      }
      texto += `${minutosRestantes}min`
    }

    if (texto === '') {
      texto = '0h'
    }

    return texto
  },
  TimeStringToDate: timeString => {
    const date = new Date(`2000-01-01T${timeString}-0300`)
    return moment(date).utcOffset(Services.GetDeviceTimezoneOffset()).format('HH:mm')
  },
  GetDeviceTimezoneOffset: () => {
    const date = new Date()

    const offset = -date.getTimezoneOffset() / 60
    return offset
  },
  IsMinAgendavel: horarios => {
    const dataInicio = moment(horarios[0].dataInicio)
    const dataFinal = moment(horarios[horarios.length - 1].dataFinal)

    const diffMinutes = dataFinal.diff(dataInicio, 'minutes')
    return diffMinutes
  },
  FormatDuration: (minutes, isBrief = false) => {
    const duration = moment.duration(minutes, 'minutes')
    const hours = duration.hours()
    const mins = duration.minutes()

    let result = ''
    if (!isBrief) {
      if (hours > 0) {
        result += `${hours} hora${hours > 1 ? 's' : ''}`
      }
      if (mins > 0) {
        if (hours > 0) {
          result += ' e '
        }
        result += `${mins} minuto${mins > 1 ? 's' : ''}`
      }
    } else {
      if (hours > 0) {
        result += `${hours}h`
      }
      if (mins > 0) {
        if (hours > 0) {
          result += ' '
        }
        result += `${mins}m`
      }
    }
    return result
  },
  SearchCountry: (endereco, username, nome) => {
    function ReturnLabelPesquisa() {
      const parts = username.split('-')

      const nomePartes = nome.toLowerCase().split(' ').filter(Boolean)

      const indexNomeEmpresa = parts.findIndex(part => part === nomePartes[0])

      const estadoCidadeParts = parts.slice(0, indexNomeEmpresa).join(' ')

      return `${endereco} ${estadoCidadeParts}`
    }

    if (endereco) {
      // Abre uma nova aba com uma pesquisa no Google
      window.open(
        'https://www.google.com/search?q=' + encodeURIComponent(ReturnLabelPesquisa()),
        '_blank',
      )
    } else {
      const pesq = username.replace(/-/g, ' ')
      window.open('https://www.google.com/search?q=' + encodeURIComponent(pesq), '_blank')
    }
  },
  ReturnNascimento: nascimento => {
    if (nascimento) {
      // Verifica se é nesse formato dd/mm/yyyy e retorna yyyy-mm-dd
      if (nascimento.length === 10 && nascimento.includes('/')) {
        const data = nascimento.split('/')
        return `${data[2]}-${data[1]}-${data[0]}`
      } else {
        return nascimento
      }
    } else {
      return null
    }
  },
}

export default Services
